export const methodologyContent = {
  eyebrow: "METHODOLOGY & SCOPE",
  title: "How This Audit Was Conducted",
  points: [
    {
      label: "Sample Size:",
      body: "{count} active, licensed roofing contractors across North America and Australia with active digital advertising campaigns (Google Search, Meta, LSAs).",
    },
    {
      label: "Test Mechanics:",
      body: "Blind mystery-shopper simulation firing standardized high-intent residential roofing inquiries (e.g., roof replacement, active storm leak) between April 2025 and August 2026.",
    },
    {
      label: "Time Distribution:",
      body: "50% during standard working hours (9 AM – 5 PM), 50% after-hours and weekends.",
    },
    {
      label: "Measurement:",
      body: "Time-to-first-human-or-interactive-text-response tracked down to the second via automated monitoring servers.",
    },
  ],
}
